/**
 * Attentive bubble expand → optional `clickSignUpBubble` + `attentiveViewPopup`.
 *
 * Cross-origin iframe clicks never reach `document`. After a user click, expand
 * is pushed while `#attentive_creative` is focused; auto-expand usually is not.
 * Focused expand: click then view in one turn. Otherwise: view only.
 */

import {
  attentiveEventProps,
  fireViewPopupWhenImpressionCountReady,
  installDataLayerEntryListener,
  parseAttentiveEntry,
  resetDataLayerEntryListener,
} from "./attentive-data-layer";

const ATTENTIVE_SOURCE = "Attentive";
const EXPAND_EVENT = "sign-up unit expand";
const BUBBLE_TYPE = "bubble";
const CREATIVE_IFRAME_ID = "attentive_creative";

const installState = { installed: false, originalPush: null };

function handleEntry(entry: unknown): void {
  const attentive = parseAttentiveEntry(entry);
  if (!attentive || !window.maestro?.fireTrackEvent) {
    return;
  }
  if (
    attentive.source !== ATTENTIVE_SOURCE ||
    attentive.event !== EXPAND_EVENT ||
    attentive.creative_type !== BUBBLE_TYPE
  ) {
    return;
  }

  const iframe = document.getElementById(CREATIVE_IFRAME_ID);
  if (iframe != null && document.activeElement === iframe) {
    window.maestro.fireTrackEvent(
      "clickSignUpBubble",
      attentiveEventProps(attentive)
    );
  }
  fireViewPopupWhenImpressionCountReady(attentive, (props) =>
    window.maestro.fireTrackEvent("attentiveViewPopup", props)
  );
}

/** @internal Resets module state between tests. */
export function resetAttentiveBubbleClickInstallForTests(): void {
  resetDataLayerEntryListener(installState);
}

export function installAttentiveBubbleClick(): void {
  installDataLayerEntryListener(handleEntry, installState);
}
